import Vue from 'vue'
import axios from 'axios'
import decoder from 'jwt-decode'
import UAParser from 'ua-parser-js'
import Vue2Filters from 'vue2-filters'
import moment from 'moment'
import HighchartsVue from 'highcharts-vue'
import _ from 'lodash'
import localforage from 'localforage'

import session from '@/plugins/session-manager'

import App from './App.vue'
import router from './router'
import './plugins/element.js'

Vue.config.productionTip = false

moment.locale('ko')
Vue.use(require('vue-moment'), { moment })
Vue.use(Vue2Filters)
Vue.use(HighchartsVue)

const API = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 30000
})

var MainApp = null
const parser = new UAParser()
const Service = new Vue({
  methods: {
    setAccessToken (accessToken) {
      session.set('access_token', accessToken)
      API.defaults.headers.common['Authorization'] = `${process.env.VUE_APP_JWT_PREFIX} ${accessToken}`
      this.user.authenticated = true
      this.user.payload = decoder(accessToken)
    },
    async getUserInfo () {
      console.log('GET USER INFO')
      try {
        const response = await API.get(`users/${this.user.payload.identity}`)
        this.user.profile = response.data
        session.set('profile', this.user.profile)
        return response.data
      }
      catch (err) {
        console.log('GET USER INFO ERROR')
        console.log(err)
        throw Error(err)
      }
    },
    async checkAuth () {
      const accessToken = session.get('access_token')
      const profile = session.get('profile')
      if (accessToken) {
        this.setAccessToken(accessToken)
        if (profile) {
          this.user.profile = profile
          return profile
        }
        else {
          return await this.getUserInfo()
        }
      }
      else {
        throw Error('NOAUTH')
      }
    },
    getOSName (osCode) {
      switch (osCode) {
        case 1: return 'windows'
        case 2: return 'linux'
        case 3: return 'osx'
        case 4: return 'android'
        case 5: return 'ios'
        default: return 'unknown'
      }
    },
    validate (value, rules) {
      for (let i=0; i<rules.length; i++) {
        let ret = this.rules[rules[i]](value)
        if(ret !== true) return ret
      }
      return true
    },
    saveProfileToSession () {
      session.set('profile', this.user.profile)
    },
    logout () {
      API.put('access/off')
      delete API.defaults.headers.common['Authorization']
      session.remove('access_token')
      session.remove('profile')
      this.user.authenticated = false
      this.user.profile = null
      this.user.payload = null
      // 화면 리프레시로 메세지 출력안됨
      // this.$emit('alert-modal', '로그아웃됬습니다.')
      window.location.href = process.env.BASE_URL
      // router.push({name: 'Login'})
    },
    getPaymentMethod(key, value) {
      let p = {}
      p[key] = value
      return (_.find(this.paymentMethods, p) || {value: 'Unknown', name: 'Unknown'})
    },
    async forceLogin (token) {
      console.log('[FORCE LOGIN]')
      try {
        await MainApp.$confirm(
          `
            강제로그인 기능은 <span class="alert-text">꼭 필요한 경우</span>에만 사용해야 하며<br>
            강제로그인 후 <span class="alert-text">흔적이 남는 행동</span>을 하면 안됩니다.<br>
            강제로그인을 실행 하시겠습니까?
          `, 
          '강제로그인', 
          {
            confirmButtonText: '강제로그인',
            cancelButtonText: '취소',
            type: 'danger',
            dangerouslyUseHTMLString: true
          }
        )

        console.log(`[FORCE LOGIN CONFIRMED: ${token}]`)
        window.open('https://admin.linkmemine.com/#/access/auth_token?token='+ token)
      }
      catch (e) {
        console.log(`[FORCE LOGIN CANCEL: ${e}]`)
      }
    },
    sortHistory (history) {
      if (!history) return []
      let favorate = history.filter(v => v.favorate)
      history = history.filter(v => !v.favorate)
      history = history.concat(favorate)
      _.reverse(history)
      return history
    },
    async addHistory (company) {
      let history = await localforage.getItem('history')
      if (!history) history = [company]
      else {
        let exist = _.findIndex(history, {pk: company.pk})
        if (exist === -1) history.push(company)
        else {
          history.splice(exist, 1)
          history.push(company)
        }

        let tmp = history.filter(v => !v.favorate)
        if (tmp.length > 20) {
          let rem = tmp.shift()
          _.remove(history, v => v.pk === rem.pk)
        }
      }
      await localforage.setItem('history', history)
      return this.sortHistory(history)
    },
    async removeHistory (company) {
      let history = await localforage.getItem('history')
      if (!history) return []

      _.remove(history, v => v.pk === company.pk)
      await localforage.setItem('history', history)
      return this.sortHistory(history)
    },
    async getHistory () {
      let history = await localforage.getItem('history')
      return this.sortHistory(history)
    }
  },
  data () {
    return {
      user: {
        authenticated: false,
        payload: null
      },
      moment: moment,
      localdb: localforage,
      ua: parser.getResult(),
      requestModule: axios, 
      serviceList: [],
      extLinks: {
        android: 'https://play.google.com/store/apps/details?id=net.koino.anysupportMobile',
        ios: 'https://itunes.apple.com/kr/app/%EB%AA%85%ED%95%A8%EC%8A%A4%EC%BA%90%EB%84%88-business-card-reader-pro/id347345474?mt=8'
      },
      rules: {
        required: (v) => !!v || '필수 항목이 누락됬습니다',
        id: (v) => /[a-zA-Z0-9_]/.test(v) || '아이디는 영문, 숫자, _ 조합만 가능합니다.',
        password: (v) => /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/gm.test(v) || '8자 이상의 대소문자, 숫자 한개 이상씩 포함',
        sequential: (s) => {
          for (let i in s) if (+s[+i+1] == +s[i]+1 && +s[+i+2] == +s[i]+2) return '연속된 문자 혹은 숫자를 쓸 수 없습니다.'
          for(let i in s) {
            if (String.fromCharCode(s.charCodeAt(i)+1) == s[+i+1] && String.fromCharCode(s.charCodeAt(i)+2) == s[+i+2]) return '연속된 문자 혹은 숫자를 쓸 수 없습니다.'
          }
          return true;
        },
        repetitive: (v) => !/(\w)\1{2,}/.test(v) || '동일한 문자(숫자)를 3번이상 반복할 수 없습니다.',
        email: (v) => /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g.test(v) || '잘못된 이메일 형식입니다.',
        phone: (v) => /^[0-9].{1,3}-[0-9].{2,3}-[0-9].{3,3}$/.test(v) || '-을 포함한 올바른 전화번호를 입력해주세요.',
        ip: (v) => /\b(?:(?:2(?:[0-4][0-9]|5[0-5])|[0-1]?[0-9]?[0-9])\.){3}(?:(?:2([0-4][0-9]|5[0-5])|[0-1]?[0-9]?[0-9]))\b/ig.test(v) || '올바른 형태의 IP를 적어주세요.'
      },
      licenseType: [
        { value: 'Free', name: 'Free', disabled: true },
        { value: 'Basic', name: 'Basic' },
        { value: 'Corporate', name: 'Corporate' }
      ],
      paymentMethods: [
        { value: 'Free', name: 'Free' },
        { value: 'Superadmin', name: 'Superadmin' },
        { value: 'SC0010', name: '신용카드' },
        { value: 'SC0030', name: '계좌이체' },
        { value: 'SC0060', name: '핸드폰 결제' },
        { value: '무통장입금', name: '무통장입금' },
        { value: '무상제공', name: '무상제공' }
      ],
      memoType: [
        '영업상담', '기술지원', '세계발행', '기타'
      ]
    }
  }
})

Vue.prototype.$http = API
Vue.prototype.$service = Service

const initMainApp = () => {
  MainApp = new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')
}

Service.checkAuth()
  .then(() => { initMainApp() })
  .catch(() => { initMainApp() })

export {
  Service,
  API,
  MainApp
}
